"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.count = count;
exports.take = take;
exports.takeRight = takeRight;
exports.takeRandom = takeRandom;
exports.updateAt = updateAt;
function count(collection, filter) {
    let matchCount = 0;
    for (let i = 0; i < collection.length; i++) {
        if (filter(collection[i])) {
            matchCount++;
        }
    }
    return matchCount;
}
function take(collection, quantity = 1) {
    return [...collection].splice(0, quantity);
}
function takeRight(collection, quantity = 1) {
    return [...collection].splice(-quantity, quantity);
}
function takeRandom(collection) {
    return collection[Math.floor(Math.random() * collection.length)];
}
function updateAt(collection, index, handler) {
    const target = collection[index];
    if (!target) {
        return collection;
    }
    return [...collection.slice(0, index), handler(target), ...collection.slice(index + 1)];
}
//# sourceMappingURL=lib.js.map